const ROUTES = {
  "/": {
    "name": "HomePage9feb9963Cd9445f6A5ad064d03fb1d63",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPage6d514c92A76d4abb871c46b0286fb4f2",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/local-partnership": {
    "name": "LocalPartnershipPage7a8a199c1b5746aaB50bCe94a3a28449",
    "type": "HTML",
    "key": "local-partnership-page"
  },
  "/apply/*": {
    "name": "ApplicationPagesC1bb3b0a6d9b43fd879f7baa4a94f6df",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "PublicContactPageE526fa517d8842b8A096D2e1099604fa",
    "type": "HTML",
    "key": "public-contact-page"
  },
  "/events/public": {
    "name": "PublicEventsPage6ee7d8adC1764f1eB2635ceabf54bab7",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/faq": {
    "name": "PublicFaqPage71c75f3a97974ac6979466f569df0be3",
    "type": "HTML",
    "key": "public-faq-page"
  },
  "/join": {
    "name": "JoinUsPage28384af03b8a4021B846B253a994cf4e",
    "type": "HTML",
    "key": "join-us-page"
  }
};

export default ROUTES;